// extracted by mini-css-extract-plugin
export default {"container":"Zz-z","dimension":"_z-z","dimensionLabels":"aA-z"};